import { FC, useState, useEffect } from 'react';
import cn from 'classnames';
import { IFeature, IFeatureProduct } from 'mod/feature/interface';
import { getModuleCode, getModuleElementId, getWrapStyle } from 'mod/feature/utils';
import { autoTrackImp } from '@base/lib/Tracker';
import FeatureSwiper from 'components/shop/FeatureSwiper';
import { ListProduct, listProductStyles, TListProductElement } from '@app/common/ListProduct';
import ViewMoreCard from 'mod/feature/ViewMoreCard'
import { ListProductProps as IOldListProductProps } from '@base/snippets/ListProduct';
import { LIST_ITEM_TYPE_BANNER } from 'mod/product-list/constant';
import homeStyles from '@app/shop/index.module.less';
import titleStyles from 'app/styles/modules/title.module.less';
import styles from './index.module.less';
import useSwiperProducts from 'mod/feature/useSwiperProducts';
import SuperFlashsaleItem from '@app/shop/SwiperFlashsaleProducts/SuperFlashsaleItem';
import { observer, useStoreState } from 'base/store';
import { IProduct } from 'mod/product/interface'

function transElements(elements: IOldListProductProps['elements']): TListProductElement[] {
    if (!elements) {
        return ['title', 'rate', 'prices', 'points', 'options'];
    }

    const map = {
        name: 'title',
        price: 'prices',
        flashsale: 'progress',
    };

    return elements.map(elem => map[elem] || elem)
}

const mergeShowList = (superFlashSaleList, list) => {
    // 将第一个SuperFlashsale商品塞进列表
    if (!!superFlashSaleList.length) {
        return [
            {
                ...superFlashSaleList[1],
                listType: 'superFlashSale'
            },
            ...list
        ]
    } else {
        return list
    }
}

const SwiperProducts: FC<{ data: IFeatureProduct }> = ({ data }) => {
    const {
        config: {
            columnWidth = 230,
            spaceBetweenColumns = 20,
            spaceAroundPicture = 20,
            spaceBelowPicture = 0,
            showTag = true,
            elements = ['name', 'rate', 'price', 'underlinedPrice', 'flashsale', 'points', 'options'],
        },
    } = data;

    const { list, isFetchedList } = useSwiperProducts({ data })

    const moduleElementId = getModuleElementId(data);
    const moduleCode = getModuleCode(data as IFeature);

    return (!list.length && isFetchedList) ? null : (
        <FeatureSwiper
            id={moduleElementId}
            data-t-mod={moduleCode}
            isFetchedList={isFetchedList}
            className={homeStyles.wrapper}
            style={getWrapStyle(data)}
            data={{
                ...data,
                lists: list
            }}
            title={{ className: cn(titleStyles.title, homeStyles.title) }}
            swiper={{
                id: 'js-swiper-wrap',
                className: homeStyles.swiper,
                slidesPerView: 'auto',
                slidesPerGroupAuto: true,
                spaceBetween: spaceBetweenColumns,
                pagination: false,
                onSlideChangeTransitionEnd: () => autoTrackImp(),
                extraRender: {
                    afterList: (
                        <ViewMoreCard
                            className={cn(styles.more, 'g-view-more-card')}
                            link={data.readMoreLink}
                            linkText={data.readMoreTitle}
                            style={{ width: columnWidth }}
                        />
                    )
                },
                render: (item, index) => item.type === LIST_ITEM_TYPE_BANNER ? null : (
                    <ListProduct
                        className={cn(listProductStyles.product, styles.product)}
                        style={{ width: `${columnWidth}px` }}
                        item={item}
                        imageSize={columnWidth - (spaceAroundPicture * 2)}
                        elements={transElements(elements)}
                        picture={{
                            tags: showTag,
                            spaceAroundPicture,
                            spaceBelowPicture
                        }}
                        prices={{ showMarketPrice: elements.includes('underlinedPrice') }}
                        track={{
                            module: moduleCode,
                            itemType: item.type,
                            position: index + 1,
                        }}
                    />
                )
            }}
        />
    );
}

export default observer(SwiperProducts);
